import Resource from "./Resource.class"

export default Resource